import React from 'react';
import { Loader2 } from 'lucide-react';

const PageLoader: React.FC<{ message?: string }> = ({
  message = 'Loading...',
}) => (
  <div className='flex flex-col items-center justify-center min-h-[60vh] w-full'>
    <Loader2 className='h-10 w-10 animate-spin text-muted-foreground mb-4' />
    <span className='text-lg text-muted-foreground font-medium'>{message}</span>
  </div>
);

export default PageLoader;
